import React from 'react';

import PaymentGatewayList from './components/PaymentGatewayList';

/**
 * Payment Gateway Page Component
 * @returns {any} React node
 */
function PaymentGateway() {
  return <PaymentGatewayList />;
}

export default PaymentGateway;
